import { RouteView, PageView } from '@/components/layouts'
// 委托查询

const DelegatedInquiry = () => import(/* webpackChunkName: "DelegatedInquiry" */ '@/views/spot-purchase-sale-inquiry/delegated-inquiry/delegated-inquiry')
// 套利委托查询
const ArbitrageInquiry = () => import(/* webpackChunkName: "ArbitrageInquiry" */ '@/views/spot-purchase-sale-inquiry/delegated-inquiry/arbitrage-inquiry')
// 成交查询
const transactionInquiry = () => import(/* webpackChunkName: "transactionInquiry" */ '@/views/spot-purchase-sale-inquiry/transaction-inquiry/transaction-inquiry')
// 套利成交查询
const arbitrageTransactionInquiry = () => import(/* webpackChunkName: "arbitrageTransactionInquiry" */ '@/views/spot-purchase-sale-inquiry/transaction-inquiry/arbitrage-transaction-inquiry')
// 订货查询
const orderInquiry = () => import(/* webpackChunkName: "orderInquiry" */ '@/views/spot-purchase-sale-inquiry/order-inquiry/order-inquiry')
// 套利订货查询
const arbitrageOrderInquiry = () => import(/* webpackChunkName: "arbitrageOrderInquiry" */ '@/views/spot-purchase-sale-inquiry/order-inquiry/arbitrage-order-inquiry')
// 交收查询
const settlementInquiry = () => import(/* webpackChunkName: "settlementInquiry" */ '@/views/spot-purchase-sale-inquiry/settlement-inquiry/settlement-inquiry')
// 交收办理查询
const settlementTransaction = () => import(/* webpackChunkName: "settlementTransaction" */ '@/views/spot-purchase-sale-inquiry/settlement-inquiry/settlement-transaction')
// 到期交收通知单
const expireNotice = () => import(/* webpackChunkName: "expireNotice" */ '@/views/spot-purchase-sale-inquiry/settlement-inquiry/expire-notice')
// 提前交收通知单
const advanceNotice = () => import(/* webpackChunkName: "advanceNotice" */ '@/views/spot-purchase-sale-inquiry/settlement-inquiry/advance-notice')
// 交易费用查询
const transactionCostInquiry = () => import(/* webpackChunkName: "transactionCostInquiry" */ '@/views/spot-purchase-sale-inquiry/transaction-cost-inquiry/transaction-cost-inquiry')
// 盈亏明细查询
const breakevenDetailsInquiry = () => import(/* webpackChunkName: "breakevenDetailsInquiry" */ '@/views/spot-purchase-sale-inquiry/breakeven-details-inquiry/breakeven-details-inquiry')
// 月报表
const monthlyReport = () => import(/* webpackChunkName: "monthlyReport" */ '@/views/spot-purchase-sale-inquiry/transaction-report-inquiry/monthly-report')
// 购销计划一览表
const purchaseSaleList = () => import(/* webpackChunkName: "purchaseSaleList" */ '@/views/spot-purchase-sale-inquiry/transaction-report-inquiry/purchase-sale-list')
// 货款账户日报表
const DailyStatement = () => import(/* webpackChunkName: "DailyStatement" */ '@/views/spot-purchase-sale-inquiry/payment-account/daily-statement')
// 货款账户暂扣款项表
const WithholdingPayment = () => import(/* webpackChunkName: "WithholdingPayment" */ '@/views/spot-purchase-sale-inquiry/payment-account/withholding-payment')
// 货款查询
const PaymentForGoods = () => import(/* webpackChunkName: "PaymentForGoods" */ '@/views/spot-purchase-sale-inquiry/payment-account/payment-for-goods')
export default {
  path: '/spot-purchase-sale-inquiry',
  name: 'spot-purchase-sale-inquiry',
  component: RouteView,
  meta: { title: '现货购销查询', keepAlive: false, icon: 'iconfont xianhuogouxiaochaxun' },
  children: [
    {
      path: '/spot-purchase-sale-inquiry/transaction-report-inquiry',
      name: '/spot-purchase-sale-inquiry/transaction-report-inquiry',
      component: PageView,
      meta: { title: '交易报表查询', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/spot-purchase-sale-inquiry/transaction-report-inquiry/monthly-report',
          name: '/spot-purchase-sale-inquiry/transaction-report-inquiry/monthly-report',
          component: monthlyReport,
          meta: { title: '月报表', keepAlive: false, action: [] }
        },
        {
          path: '/spot-purchase-sale-inquiry/transaction-report-inquiry/purchase-sale-list',
          name: '/spot-purchase-sale-inquiry/transaction-report-inquiry/purchase-sale-list',
          component: purchaseSaleList,
          meta: { title: '购销计划一览表', keepAlive: false, action: [] }
        }
      ]
    },
    {
      path: '/spot-purchase-sale-inquiry/delegated-inquiry',
      name: '/spot-purchase-sale-inquiry/delegated-inquiry',
      component: PageView,
      meta: { title: '委托查询', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/spot-purchase-sale-inquiry/delegated-inquiry/delegated-inquiry',
          name: '/spot-purchase-sale-inquiry/delegated-inquiry/delegated-inquiry',
          component: DelegatedInquiry,
          meta: { title: '委托查询', keepAlive: false, action: [] }
        },
        {
          path: '/spot-purchase-sale-inquiry/delegated-inquiry/arbitrage-inquiry',
          name: '/spot-purchase-sale-inquiry/delegated-inquiry/arbitrage-inquiry',
          component: ArbitrageInquiry,
          meta: { title: '套利委托查询', keepAlive: false, action: [] },
        }
      ]
    },
    {
      path: '/spot-purchase-sale-inquiry/transaction-inquiry',
      name: '/spot-purchase-sale-inquiry/transaction-inquiry',
      component: PageView,
      meta: { title: '成交查询', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/spot-purchase-sale-inquiry/transaction-inquiry/transaction-inquiry',
          name: '/spot-purchase-sale-inquiry/transaction-inquiry/transaction-inquiry',
          component: transactionInquiry,
          meta: { title: '成交查询', keepAlive: false, action: [] }
        },
        {
          path: '/spot-purchase-sale-inquiry/transaction-inquiry/arbitrage-transaction-inquiry',
          name: '/spot-purchase-sale-inquiry/transaction-inquiry/arbitrage-transaction-inquiry',
          component: arbitrageTransactionInquiry,
          meta: { title: '套利成交查询', keepAlive: false, action: [] }
        }
      ]
    },
    {
      path: '/spot-purchase-sale-inquiry/order-inquiry',
      name: '/spot-purchase-sale-inquiry/order-inquiry',
      component: PageView,
      meta: { title: '订货查询', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/spot-purchase-sale-inquiry/order-inquiry/order-inquiry',
          name: '/spot-purchase-sale-inquiry/order-inquiry/order-inquiry',
          component: orderInquiry,
          meta: { title: '订货查询', keepAlive: false, action: [] }
        },
        {
          path: '/spot-purchase-sale-inquiry/order-inquiry/arbitrage-order-inquiry',
          name: '/spot-purchase-sale-inquiry/order-inquiry/arbitrage-order-inquiry',
          component: arbitrageOrderInquiry,
          meta: { title: '套利订货查询', keepAlive: false, action: [] }
        }
      ]
    },
    {
      path: '/spot-purchase-sale-inquiry/settlement-inquiry',
      name: '/spot-purchase-sale-inquiry/settlement-inquiry',
      component: PageView,
      meta: { title: '交收查询', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/spot-purchase-sale-inquiry/settlement-inquiry/settlement-inquiry',
          name: '/spot-purchase-sale-inquiry/settlement-inquiry/settlement-inquiry',
          component: settlementInquiry,
          meta: { title: '交收查询', keepAlive: false, action: [] }
        },
        {
          path: '/spot-purchase-sale-inquiry/settlement-inquiry/settlement-transaction',
          name: '/spot-purchase-sale-inquiry/settlement-inquiry/settlement-transaction',
          component: settlementTransaction,
          meta: { title: '现货交收办理查询', keepAlive: false, action: [] }
        },
        {
          path: '/spot-purchase-sale-inquiry/settlement-inquiry/expire-notice',
          name: '/spot-purchase-sale-inquiry/settlement-inquiry/expire-notice',
          component: expireNotice,
          meta: { title: '到期交收通知单', keepAlive: false, action: [] }
        },
        {
          path: '/spot-purchase-sale-inquiry/settlement-inquiry/advance-notice',
          name: '/spot-purchase-sale-inquiry/settlement-inquiry/advance-notice',
          component: advanceNotice,
          meta: { title: '提前交收通知单', keepAlive: false, action: [] }
        },

      ]
    },
    {
      path: '/spot-purchase-sale-inquiry/transaction-cost-inquiry',
      name: '/spot-purchase-sale-inquiry/transaction-cost-inquiry',
      component: PageView,
      meta: { title: '交易费用查询', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/spot-purchase-sale-inquiry/transaction-cost-inquiry/transaction-cost-inquiry',
          name: '/spot-purchase-sale-inquiry/transaction-cost-inquiry/transaction-cost-inquiry',
          component: transactionCostInquiry,
          meta: { title: '交易费用查询', keepAlive: false, action: [] }
        }
      ]
    },
    {
      path: '/spot-purchase-sale-inquiry/breakeven-details-inquiry',
      name: '/spot-purchase-sale-inquiry/breakeven-details-inquiry',
      component: PageView,
      meta: { title: '盈亏明细查询', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/spot-purchase-sale-inquiry/breakeven-details-inquiry/breakeven-details-inquiry',
          name: '/spot-purchase-sale-inquiry/breakeven-details-inquiry/breakeven-details-inquiry',
          component: breakevenDetailsInquiry,
          meta: { title: '盈亏明细查询', keepAlive: false, action: [] }
        }
      ]
    },
    {
      path: '/spot-purchase-sale-inquiry/payment-account',
      name: '/spot-purchase-sale-inquiry/payment-account',
      component: PageView,
      meta: { title: '货款账户', keepAlive: false, icon: 'el-icon-star-on' },
      children: [
        {
          path: '/spot-purchase-sale-inquiry/payment-account/daily-statement',
          name: '/spot-purchase-sale-inquiry/payment-account/daily-statement',
          component: DailyStatement,
          meta: { title: '货款账户日报表', keepAlive: false, action: [] }
        },
        {
          path: '/spot-purchase-sale-inquiry/payment-account/withholding-payment',
          name: '/spot-purchase-sale-inquiry/payment-account/withholding-payment',
          component: WithholdingPayment,
          meta: { title: '货款账户暂扣款项表', keepAlive: false, action: [] }
        },
        {
          path: '/spot-purchase-sale-inquiry/payment-account/payment-for-goods',
          name: '/spot-purchase-sale-inquiry/payment-account/payment-for-goods',
          component: PaymentForGoods,
          meta: { title: '货款查询', keepAlive: false, action: [] }
        }
      ]
    }
  ]
}
